'use strict';

import {
  GET_FIRMWARE_LIST,
  UPDATE_LOADING_STATUS,
  GET_RELEASE_LIST,
  FIRMWARE_TYPE,
} from '../actions/firmware';

const defVal = {
    firmwareList: {},
    releaseList:{},
    firmwareType: [],
    loading: true,
    pageIndex: 0,
    pageSize: 10,
    total: 0,
  };
  
  export default (state = defVal, action) => {
    switch (action.type) {
      case GET_FIRMWARE_LIST:
        return Object.assign({}, state, {
          firmwareList: action.firmwareList,
        });
        
      case UPDATE_LOADING_STATUS:
        return Object.assign({}, state, {
          loading: action.loading
        });
      case GET_RELEASE_LIST:
        return Object.assign({}, state, {
            releaseList: action.releaseList,
            total: action.total,
            pageIndex: action.pageIndex,
            pageSize: action.pageSize,
        });
      case FIRMWARE_TYPE:
        return Object.assign({}, state, {
            firmwareType: action.firmwareType
        });
      default:
        return state;
    }
  };